export default __webpack_public_path__ + "static/media/varanda.27b915b7.svg";